import { scenarioCount } from "../ScenarioRerun/bulkRerunToast";

export enum BulkScenarioUploadLabel {
    MenuItem = "Upload scenarios from CSV",
    PageTitle = "Upload scenarios",
    Eyebrow = "Bulk upload",
    FormatTitles = "Format titles",
    SetCostAssumptions = "Set cost assumptions",
    SetCustomUpgrade = "Set custom upgrade",
    AddUpgrade = "Add upgrade",
    SetRunNow = "Set run now"
}

export const createScenariosLabel = (count: number): string =>
    `Create ${scenarioCount(count)}`;
